<template>
  <div class="toast-container">
    <transition-group name="fade-in">
      <div
        v-for="message in messageList"
        :key="message.msgId"
        :class="['msg-container', message.type]"
      >
        <div class="toast-msg">
          <div v-for="msg in message.content" :key="msg" class="msg-content">
            {{ msg }}
          </div>
        </div>
        <div class="msg-timestamp">
          {{ message.timestamp }}
        </div>
        <div
          class="msg-remove-button env-close"
          @click="remove(message.msgId)"
        />
      </div>
    </transition-group>
  </div>
</template>
<script>
import {
  getTwoDigitString,
  getBit,
  isStr,
  generateUniqueID,
  TOAST_DISABLE_NOTI,
  TOAST_CLOSE_WARNING,
  TOAST_CLOSE_ERROR,
} from '@/js/utils';
import { Toast } from '@/js/plugin';
export default {
  name: 'Toast',
  data() {
    return {
      messageList: [],
    };
  },
  computed: {
    userPreferences() {
      return this.$store.getters['user/userPreferences'];
    },
  },
  methods: {
    show({ content, type, keep, timeout }) {
      if (
        (type === 'info' && getBit(this.userPreferences, TOAST_DISABLE_NOTI)) ||
        (this.$route.path === '/testapi' && process.env.TEST_API)
      ) {
        return;
      }
      const id = generateUniqueID();
      const currentTime = new Date();
      const timeString =
        getTwoDigitString(currentTime.getHours()) +
        ':' +
        getTwoDigitString(currentTime.getMinutes()) +
        ':' +
        getTwoDigitString(currentTime.getSeconds());
      const toastParams = {
        content: isStr(content) ? [content] : content,
        msgId: id,
        type: type || 'info',
        timestamp: timeString,
        keep:
          keep ||
          (type === 'alert' &&
            !getBit(this.userPreferences, TOAST_CLOSE_ERROR)) ||
          (type === 'warning' &&
            !getBit(this.userPreferences, TOAST_CLOSE_WARNING)),
        timeout: parseInt(timeout) || 5000,
      };
      // console.log(toastParams)
      this.messageList.push(toastParams);
      if (!toastParams.keep) {
        setTimeout(() => {
          this.remove(id);
        }, toastParams.timeout);
      }
    },
    remove(id) {
      const index = this.messageList.findIndex((el) => el.msgId === id);
      if (index !== -1) {
        this.messageList.splice(index, 1);
      }
    },
  },
  beforeMount() {
    Toast.EventBus.$on('show', this.show);
  },
  beforeDestroy() {
    Toast.EventBus.$off();
  },
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 50%;
  transform: translateX(50%);
  width: 80%;
  max-width: 320px;
}

.msg-container {
  position: relative;
  border-radius: 3px;
  opacity: 0.95;
}

.msg-remove-button {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

.msg-remove-button::after,
.msg-remove-button::before {
  background-color: #fff;
}

.toast-msg {
  overflow: hidden;
  padding: 25px 50px 25px 55px;
  border-radius: 3px;
  background-position: 15px center;
  background-repeat: no-repeat;
  background-size: 40px;
  box-shadow: 0 2px 10px #2f2f2f;
  color: #fff;
  box-sizing: border-box;
  line-height: 24px;
  margin-bottom: 6px;
  text-align: center;
}

.msg-timestamp {
  color: #fff;
  font-size: 0.65em;
  text-align: right;
  position: absolute;
  bottom: 5px;
  right: 10px;
}

.msg-content {
  display: block;
  word-wrap: break-word;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  cursor: default;
}

.info {
  background-color: #169f84;
}

.info .toast-msg {
  background-image: url(~@/assets/img/icon_noti_msg.png);
}

.warning {
  background-color: #edc211;
}

.warning .toast-msg {
  background-image: url(~@/assets/img/icon_warning_msg.png);
}

.alert {
  background-color: #a43434;
}

.alert .toast-msg {
  background-image: url(~@/assets/img/icon_error_msg.png);
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: 0.5s ease-in;
}
</style>
